import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Formik, useFormikContext } from 'formik'
import { Form, Row, Col, Button, Card, Checkbox } from 'antd'

const FormikStateSpy = ({ onDirtyChange }) => {
  const { dirty } = useFormikContext()

  useEffect(() => {
    if (onDirtyChange) {
      onDirtyChange(dirty)
    }
  }, [dirty, onDirtyChange])

  return null
}

const SamSettingsForm = ({
  initialValues,
  onSubmit,
  isSubmitAllowed,
  innerRef,
  onDirtyChange,
}) => (
  <Card className="user-info-card" style={{ marginTop: '10px' }}>
    <Formik
      innerRef={innerRef}
      initialValues={{
        is_dob_required: true,
        is_ssn_required: true,
        ...initialValues,
      }}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({ handleSubmit, dirty, values, setFieldValue }) => (
        <Form onFinish={handleSubmit} className="user-form" layout="vertical">
          <FormikStateSpy onDirtyChange={onDirtyChange} />

          <Row justify="space-between">
            <Col>
              <Form.Item>
                <div className="user-form__title">Producer Flow Options</div>
              </Form.Item>
            </Col>
          </Row>

          <Row style={{ marginBottom: '16px' }}>
            <Col span={24}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '8px',
                  alignItems: 'flex-start',
                }}
              >
                <Checkbox
                  name="is_dob_required"
                  checked={values.is_dob_required}
                  onChange={event =>
                    setFieldValue('is_dob_required', event.target.checked)
                  }
                >
                  Include DOB
                </Checkbox>

                <Checkbox
                  style={{ marginLeft: 0 }}
                  name="is_ssn_required"
                  checked={values.is_ssn_required}
                  onChange={event =>
                    setFieldValue('is_ssn_required', event.target.checked)
                  }
                >
                  Include SSN
                </Checkbox>
              </div>
            </Col>
          </Row>

          {isSubmitAllowed && (
            <Button
              type="primary"
              ghost
              htmlType="submit"
              disabled={!dirty}
              style={{ marginTop: '8px' }}
            >
              Save Changes
            </Button>
          )}
        </Form>
      )}
    </Formik>
  </Card>
)

SamSettingsForm.propTypes = {
  initialValues: PropTypes.shape({
    is_dob_required: PropTypes.bool,
    is_ssn_required: PropTypes.bool,
  }),
  onSubmit: PropTypes.func.isRequired,
  isSubmitAllowed: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onDirtyChange: PropTypes.func,
}

SamSettingsForm.defaultProps = {
  initialValues: {
    is_dob_required: true,
    is_ssn_required: true,
  },
  isSubmitAllowed: true,
  innerRef: null,
  onDirtyChange: () => {},
}

export default SamSettingsForm
